import styled from "styled-components";

export const Container = styled.div`
display: flex;
flex-direction: column;
align-items: center;
    padding: 3rem;

.title{
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;

    h1{
        font-weight: 600;
    }
}

.term-and-condition-container{
      width: 100%;
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    background-color: white;
    padding: 3rem;


    h1{
        font-weight: 600;
    }
}
`